module.exports = __webpack_public_path__ + "static/media/amir_jaan_mood.85598e0e.jpg";